import L from 'leaflet';

export default class CustomBoxZoom {

	constructor (map, options) {

		this._map = map;
		this._enabled = false;
		this._configure();
		this._onDisabled = options && options.onDisabled;
		this._onEnabled = options && options.onEnabled;
	}

	enable () {

		this._map._container.style.cursor = 'crosshair';
		this._enabled = true;

		if (this._onEnabled) {
			this._onEnabled();
		}
	}

	disable () {

		if (this._enabled) {

			this._enabled = false;
			this._map.dragging.enable();
			this._map.boxZoom._container.style.cursor = '';

			if (this._onDisabled) {
				this._onDisabled();
			}
		}
	}

	_configure () {

		var boxZoom = this._map.boxZoom;
		var that = this;

		this._map.on('mousedown', function (e) {
			
			e = e.originalEvent;

			if (!that._enabled || (e.which !== 1 && e.button !== 1)) {
				return false;
			}

			boxZoom._clearDeferredResetState();
			boxZoom._resetState();

			that._map.dragging.disable();
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
			
			boxZoom._startPoint = boxZoom._map.mouseEventToContainerPoint(e);

			L.DomEvent.on(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: boxZoom._onMouseMove,
				mouseup: function (e) {
					boxZoom._onMouseUp(e);
					that.disable();
				},
				keydown: boxZoom._onKeyDown
			}, boxZoom);
		});
	}
}



// WEBPACK FOOTER //
// ./src/utils/customBoxZoom.js